// app/javascript/utils/api.js
export function fetchWithLocale(url, options = {}) {
    const locale = (document.documentElement.lang || "es").toLowerCase();

    // Ensure URL starts with /
    const cleanUrl = url.startsWith('/') ? url : `/${url}`;

    // Check if URL already has the locale prefix to avoid double-prefixing
    if (cleanUrl.startsWith(`/${locale}/`)) {
        return fetch(cleanUrl, options);
    }

    return fetch(`/${locale}${cleanUrl}`, options);
}